import { LOAD_LISTADO_OFICINAS, LOAD_MODAL_DETALLE_OFICINA, StateListadoOficina } from "../../types/objetivos/oficinaTypes";

export const loadListadoOficinas = (data: StateListadoOficina) => ({ type: LOAD_LISTADO_OFICINAS, payload: data });
export const loadDetalleOficina = (data: StateListadoOficina) => ({ type: LOAD_MODAL_DETALLE_OFICINA, payload: data });
